import React, { useEffect, useRef } from "react";

type CallbackFunction = () => void;

export function useInterval(
  callback: CallbackFunction,
  delay: number | null,
): void {
  const savedCallback = useRef<CallbackFunction>(callback);

  // Remember the latest callback.
  useEffect(() => {
    savedCallback.current = callback;
  }, [callback]);

  // Set up the interval.
  useEffect(() => {
    function tick() {
      if (savedCallback.current) {
        savedCallback.current();
      }
    }

    if (delay !== null) {
      const id = setInterval(tick, delay);
      return () => clearInterval(id);
    }
    return undefined;
  }, [delay]);
}
